// Resolves the correct print transport for a printer, honoring the per-device
// Bluetooth binding. Used by every print path (kitchen tickets, receipts,
// reports) so a Bluetooth printer never falls back to the TCP/localhost path.
//
//  - Native (Android): return { bluetoothAddress } for BT printers (the plugin
//    then uses RFCOMM); otherwise { ipAddress } for the TCP path.
//  - Electron (desktop): a bound Bluetooth printer is a local serial (COM) port,
//    so inject the bound device id as printer.port.

import { getBinding } from './printerBindings';

export function isBluetoothPrinter(printer: any): boolean {
  return (printer?.connectionType || '').toLowerCase() === 'bluetooth';
}

/** Params for the native ThermalPrinter.printHtml/printImage call. */
export function nativePrintTarget(printer: any): { ipAddress?: string; bluetoothAddress?: string } {
  if (isBluetoothPrinter(printer)) {
    const binding = getBinding(printer?.id);
    return { ipAddress: undefined, bluetoothAddress: binding?.deviceId };
  }
  return { ipAddress: printer?.ipAddress, bluetoothAddress: undefined };
}

/** Printer object for the Electron print IPC (bound COM port for BT). */
export function resolvePrinterForElectron(printer: any): any {
  if (isBluetoothPrinter(printer)) {
    const binding = getBinding(printer?.id);
    if (binding) return { ...printer, port: binding.deviceId };
  }
  return printer;
}
